import { render, staticRenderFns } from "./lawsuit_form.vue?vue&type=template&id=64103cca&scoped=true"
import script from "./lawsuit_form.vue?vue&type=script&lang=js"
export * from "./lawsuit_form.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_form.vue?vue&type=style&index=0&id=64103cca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64103cca",
  null
  
)

export default component.exports